import {CustomerContactMethod} from '../../../main/shared/enums/customer.contact.method';

export class OutreachAttemptModel {
  id?: number;
  createdBy: string;
  createdAt: string;
  contactTypes: CustomerContactMethod[];
  note?: string;
}
